import { t } from "ttag";

import type { CollectionAuthorityLevelConfig } from "metabase/common/collections/types";
import type { IconData } from "metabase/common/utils/icon";

export const OFFICIAL_COLLECTION: CollectionAuthorityLevelConfig = {
  type: "official",
  get name() {
    return t`Official`;
  },
  icon: "official_collection",
  color: "core-yellow-saturated",
  get tooltips() {
    return {
      default: t`Official collection`,
      belonging: t`Belongs to an Official collection`,
    };
  },
};

export const OFFICIAL_COLLECTION_ICON: IconData = {
  name: "official_collection",
  color: "core-yellow-saturated",
};
